module.exports = __webpack_public_path__ + "media/svg-new/online-meeting-0c4f5c3d.svg";